module.exports = __webpack_public_path__ + "img/Mixed-fruits-600x395.cb6a569d.jpg";